// Mock data for MTS Energia landing page

export const companyInfo = {
  name: "MTS ENERGIA",
  tagline: "THINKING POWER",
  legalName: "MTS Energia s.r.l.",
  foundingYear: 2007,
  heroBannerImage: "https://i.ibb.co/1f1LYFp4/FV-a-terra-3-1.jpg",
  divisionsBackgroundImage: "https://i.ibb.co/4nBPXKB2/21.jpg",
  description: "Operatore energetico integrato ed autonomo italiano, proiettato verso la crescita delle fonti rinnovabili, l'edilizia consapevole e la manutenzione di impianti fluida ed efficiente.",
  mission: "MTS Energia punta alla diversificazione delle energie rinnovabili, legando indipendenza ed efficienza energetica per uno sviluppo sostenibile, nel quale aspetti economici, sociali ed ambientali possano interagire e valorizzarsi.",
  address: "Corso della Repubblica n° 255/a, 03043 Cassino (FR), Italia",
  registeredOffice: "Corso della Repubblica n° 255/a, 03043 Cassino (FR), Italia",
  operationalOffice: "Cassino (FR), Italia",
  email: "info@mtsenergia.com",
  administrationEmail: "amministrazione@mtsenergia.com",
  phone: "+39 0776 154325",
  mobile: "+39 320 270 4394",
  fax: "+39 0776 180 0573",
  vat: "IT02492630609",
  contactPerson: "Dr. Michele Pontone",
  contactRole: "CEO & Founder",
  certification: "Esperto Gestione Energia certificato n° 2798",
  mapsQuery: "Corso della Repubblica 255/a, 03043 Cassino FR, Italia"
};

export const statistics = [
  {
    id: 1,
    value: "80+",
    label: "MW Installati",
    suffix: "MW"
  },
  {
    id: 2,
    value: "50+",
    label: "Progetti Completati",
    suffix: "+"
  },
  {
    id: 3,
    value: "19",
    label: "Anni di Esperienza",
    suffix: "Anni"
  },
  {
    id: 4,
    value: "57",
    label: "Risparmio Energetico",
    suffix: "%"
  }
];

export const divisions = [
  {
    id: 1,
    title: "Operation & Maintenance",
    subtitle: "DIVISIONE ENERGIA",
    description: "Monitoraggio, manutenzione e controllo degli impianti per l'ottimizzazione e la massima resa produttiva.",
    icon: "zap",
    color: "#FF8C42",
    services: [
      "Impianti Fotovoltaici",
      "Impianti Eolici",
      "Impianti a Biomasse",
      "Impianti Idroelettrici",
      "Gestione amministrativa impianti",
      "Gestione strategica del portafoglio energetico"
    ],
    benefit: "Attraverso una consulenza strategica e servizi in linea con le esigenze aziendali e legislative, MTS Energia garantisce il massimo ritorno dell'investimento."
  },
  {
    id: 2,
    title: "Consulting",
    subtitle: "SERVIZI DI CONSULENZA",
    description: "Identificazione delle opportunità di investimento e assistenza in tutte le fasi di acquisto di un progetto o asset operativo.",
    icon: "briefcase",
    color: "#4A90E2",
    services: [
      "Identificazione opportunità di investimento",
      "Gestione integrale pre-due diligence",
      "Assistenza tecnica, legale e commerciale",
      "Project finance e project leasing",
      "Corporate finance",
      "Valutazione alternative di investimento"
    ],
    benefit: "Aiutiamo gli investitori a valutare le diverse alternative e a scegliere la tipologia e le modalità più adatte per massimizzare il ritorno dell'investimento."
  },
  {
    id: 3,
    title: "Maintenance",
    subtitle: "DIVISIONE MANUTENZIONE",
    description: "Manutenzione di impianti industriali di vari settori tra cui metallurgia, carpenteria metalmeccanica medio-pesante e settore produttivo.",
    icon: "wrench",
    color: "#50C878",
    services: [
      "Manutenzione periodica",
      "Manutenzione straordinaria",
      "Manutenzione programmata",
      "Manutenzione preventiva",
      "Sicurezza lavoratori",
      "Ottimizzazione risorse"
    ],
    benefit: "Aumentare la vita delle linee produttive, riduzione strategica dei consumi e ottimizzazione delle risorse."
  },
  {
    id: 4,
    title: "Revamping",
    subtitle: "REVAMPING DEGLI IMPIANTI",
    description: "Attraverso verifiche eseguite le aziende potranno verificare lo stato dei materiali ed intraprendere operazioni di rinnovo dell'impianto.",
    icon: "refresh-cw",
    color: "#9B59B6",
    services: [
      "Verifica stato materiali",
      "Rinnovo impianti industriali",
      "Upgrade sistemi obsoleti",
      "Massima produttività ed efficienza",
      "Sistemi di grande scala",
      "Esperienza decennale"
    ],
    benefit: "Con decenni di esperienza, competenze ed expertise acquisite, specialmente per i sistemi di grande scala, MTS Energia può portare impianti obsoleti al massimo livello di upgrade."
  },
  {
    id: 5,
    title: "Costruzioni",
    subtitle: "DIVISIONE EDILIZIA",
    description: "Esperienza nella costruzione industriale e civile, gestendo nuove costruzioni, ristrutturazioni di edifici residenziali, produttivi e industriali.",
    icon: "building-2",
    color: "#E74C3C",
    services: [
      "Nuove costruzioni",
      "Ristrutturazioni edifici residenziali",
      "Edifici produttivi e industriali",
      "Manutenzione ordinaria e straordinaria",
      "Opere di urbanizzazione",
      "Opere civili e industriali 'chiavi in mano'"
    ],
    benefit: "Gestione completa di progetti edilizi con approccio integrato, dalla progettazione alla realizzazione."
  },
  {
    id: 6,
    title: "Risparmio Energetico",
    subtitle: "UP-GRADE DEGLI IMPIANTI",
    description: "MTS Energia interviene su impianti esistenti per ridurre il fabbisogno energetico del cliente.",
    icon: "leaf",
    color: "#27AE60",
    services: [
      "Studio preliminare dei consumi",
      "Audit energetico gratuito",
      "Progettazione interventi potenziali",
      "Energy Performance Contract",
      "Collaborazione con ES.Co. nazionali",
      "Finanziamento bancario"
    ],
    benefit: "Nessun rischio tecnico e finanziario, poiché il compenso alla ES.Co. dipende dai risparmi conseguiti. Contratto fino a 10 anni."
  }
];

export const projects = [
  {
    id: 1,
    name: "Parco Solare Cutro",
    location: "Cutro (CZ)",
    type: "Installazione su serra",
    power: "5 MWp",
    modules: "Moduli policristallini",
    image: "https://i.ibb.co/9H9WgdV4/22.jpg"
  },
  {
    id: 2,
    name: "Parco Solare Tarquinia",
    location: "Tarquinia (VT)",
    type: "Installazione su serra",
    power: "1.0 MWp",
    modules: "Moduli policristallini",
    image: "https://i.ibb.co/4nBPXKB2/23.jpg"
  },
  {
    id: 3,
    name: "Parco Solare Francofonte",
    location: "Francofonte (SR)",
    type: "Installazione a terra",
    power: "3.44 MWp",
    modules: "Moduli amorfi",
    image: "https://i.ibb.co/4nBPXKB2/23.jpg"
  },
  {
    id: 4,
    name: "Parco Solare Basilicata",
    location: "Basilicata",
    type: "Installazione a terra",
    power: "9 MWp",
    modules: "9 parchi solari da 1 MWp ciascuno",
    image: "https://i.ibb.co/FqYL8Hqn/25.jpg"
  },
  {
    id: 5,
    name: "Parco Solare Melilli",
    location: "Melilli (SR)",
    type: "Installazione a terra",
    power: "8.1 MWp",
    modules: "Moduli policristallini",
    image: "https://i.ibb.co/hxySKJxH/29.jpg"
  },
  {
    id: 6,
    name: "Parco Solare Eboli",
    location: "Eboli (SA)",
    type: "Installazione su serra",
    power: "5.0 MWp",
    modules: "Moduli policristallini",
    image: "https://i.ibb.co/zHt9b38Q/27.jpg"
  },
  {
    id: 7,
    name: "Impianto Monteiasi",
    location: "Monteiasi (TA)",
    type: "Installazione su tetto industriale",
    power: "344 kWp",
    modules: "Moduli policristallini",
    image: "https://i.ibb.co/F4tLg8Nm/28.jpg"
  }
];

export const caseStudies = [
  {
    id: 1,
    slug: "scuola-primaria-dante-alighieri",
    title: "Scuola Primaria Dante Alighieri",
    location: "Ceprano (FR)",
    type: "Istituto Comprensivo",
    installation: "Tetto piano",
    power: "25 kWp",
    modules: "QCells 280W policristallini",
    inverter: "ABB TRIO-20.0/27.6-TL",
    heatPump: "AERMEC MVA 40 KWp",
    savings: 53,
    image: "https://i.ibb.co/WNw1Yh9V/17.jpg",
    galleryImages: [
      "https://i.ibb.co/tpgtsF90/14.jpg",
      "https://i.ibb.co/XxjCs8pt/15.jpg",
      "https://i.ibb.co/wNv210tq/16.jpg",
      "https://i.ibb.co/zTsBBGk4/17.jpg",
      "https://placehold.co/1200x800?text=Imagem+5"
    ],
    interventions: [
      "Studio dei consumi",
      "Audit energetico",
      "Installazione moduli fotovoltaici per pompe di calore",
      "Sostituzione illuminazione tradizionale con LED"
    ]
  },
  {
    id: 2,
    slug: "scuola-secondaria-primo-grado",
    title: "Scuola Secondaria di Primo Grado",
    location: "Ceprano (FR)",
    type: "Istituto Comprensivo",
    installation: "Copertura a shed",
    power: "50 kWp",
    modules: "QCells 280W policristallini",
    inverter: "ABB TRIO-20.0/27.6-TL",
    heatPump: "AERMEC MVA 80 KWp",
    savings: 57,
    image: "https://i.ibb.co/tP1xGddn/21.jpg",
    galleryImages: [
      "https://i.ibb.co/VYTp12Vn/18.jpg",
      "https://i.ibb.co/B7Qxfgw/19.jpg",
      "https://i.ibb.co/CsmcmQzL/20.jpg",
      "https://i.ibb.co/tP1xGddn/21.jpg",
    ],
    interventions: [
      "Studio dei consumi",
      "Audit energetico",
      "Installazione moduli fotovoltaici",
      "Sostituzione illuminazione tradizionale con LED"
    ]
  },
  {
    id: 3,
    slug: "Cantiere-pontecagnano",
    title: "Cantiere Pontecagnano",
    location: "Pontecagnano (Salerno)",
    type: "Cantiere",
    installation: "Copertura a shed",
    power: "MWp 1.2",
    // modules: "QCells 280W policristallini",
    // inverter: "ABB TRIO-20.0/27.6-TL",
    // heatPump: "AERMEC MVA 80 KWp",
    savings: 57,
    image: "https://i.ibb.co/mFgLhDf8/Whats-App-Image-2026-05-27-at-17-01-26.jpg",
    galleryImages: [
      "https://i.ibb.co/mFgLhDf8/Whats-App-Image-2026-05-27-at-17-01-26.jpg",
      "https://i.ibb.co/jZMpJWXs/Whats-App-Image-2026-05-27-at-17-01-34.jpg",
      "https://i.ibb.co/tpSfZVWG/Whats-App-Image-2026-05-27-at-17-01-35.jpg",
      "https://i.ibb.co/VWWJmy2m/Whats-App-Image-2026-05-27-at-17-01-35-1.jpg",
      "https://i.ibb.co/k24t6w3V/Whats-App-Image-2026-05-27-at-17-01-35-2.jpg",
    ],
    interventions: [
      "Studio dei consumi",
      "Audit energetico",
      "Installazione moduli fotovoltaici",
      "Sostituzione illuminazione tradizionale con LED"
    ]
  },
  {
    id: 4,
    slug: "Maserada sul Piave",
    title: "Maserada sul Piave",
    location: "Maserada sul Piave (PD)",
    type: "Cantiere",
    installation: "Copertura a shed",
    power: "MWp 1.0",
    // modules: "QCells 280W policristallini",
    // inverter: "ABB TRIO-20.0/27.6-TL",
    // heatPump: "AERMEC MVA 80 KWp",
    savings: 57,
    image: "https://i.ibb.co/gMrjgNn5/Whats-App-Image-2026-06-26-at-10-31-17.jpg",
    galleryImages: [
      "https://i.ibb.co/7NCD7H8L/Whats-App-Image-2026-06-26-at-10-31-17-1.jpg",
      "https://i.ibb.co/Gf3hjBQZ/Whats-App-Image-2026-06-26-at-10-31-17-2.jpg",
      "https://i.ibb.co/gZjKbWB4/Whats-App-Image-2026-06-26-at-10-31-17-3.jpg",
      "https://i.ibb.co/LXvYGwNF/Whats-App-Image-2026-06-26-at-10-31-17.jpg",
      "https://i.ibb.co/pB9R1twm/Whats-App-Image-2026-06-26-at-10-31-17-6.jpg",
    ],
    interventions: [
      "Studio dei consumi",
      "Audit energetico",
      "Installazione moduli fotovoltaici",
      "Sostituzione illuminazione tradizionale con LED"
    ]
  },
  {
    id: 5,
    slug: "Impianto su Copertura Industriale",
    title: "Impianto su Copertura Industriale",
    location: "Acerra (NA)",
    type: "Cantiere",
    installation: "Copertura a shed",
    power: "KWp 700.0",
    // modules: "QCells 280W policristallini",
    // inverter: "ABB TRIO-20.0/27.6-TL",
    // heatPump: "AERMEC MVA 80 KWp",
    savings: 57,
    image: "https://i.ibb.co/0VmZtcQX/Whats-App-Image-2026-06-26-at-10-49-58-4.jpg",
    galleryImages: [
      "https://i.ibb.co/0VmZtcQX/Whats-App-Image-2026-06-26-at-10-49-58-4.jpg",
      "https://i.ibb.co/zTx71Hwk/Whats-App-Image-2026-06-26-at-10-49-58.jpg",
      "https://i.ibb.co/8gSLrsjs/Whats-App-Image-2026-06-26-at-10-49-58-1.jpg",
      "https://i.ibb.co/N6y8fwd8/Whats-App-Image-2026-06-26-at-10-49-58-2.jpg",
      "https://i.ibb.co/RkGmkCw4/Whats-App-Image-2026-06-26-at-10-49-58-3.jpg",
    ],
    interventions: [
      "Studio dei consumi",
      "Audit energetico",
      "Installazione moduli fotovoltaici",
      "Sostituzione illuminazione tradizionale con LED"
    ]
  },
];

export const operativitaCantieri = [
  {
    id: 1,
    title: "Cantiere TUSCANIA (VT) 3 MWp",
    images: [
      "https://i.ibb.co/8LwhbFNb/40.png",
      "https://i.ibb.co/gLC4ddGz/41.png",
      "https://i.ibb.co/3mbXTDCy/42.png",
      "https://i.ibb.co/7t1TKhYs/43.png"
    ]
  },
  {
    id: 2,
    title: " San Martino di Lupari (PD) 1.8 MWp",
    images: [
      "https://i.ibb.co/MyxydBz8/44.png",
      "https://i.ibb.co/MDWgc8Hk/45.png",
      "https://i.ibb.co/C52S6bnQ/46.png",
      "https://i.ibb.co/4ZQNJFgd/47.png",
      "https://i.ibb.co/RpJkDWZX/48.png",
      "https://i.ibb.co/WWnwGJq5/49.png"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Florin Andriciuc",
    role: "Cliente Privato",
    rating: 5,
    text: "Ho installato il fotovoltaico un mese fa e sono soddisfatto della proprietà",
    date: "2 anni fa"
  }
];

export const maintenanceWorks = [
  "Preparazione e verniciatura carpenteria metallica",
  "Pulizia e lubrificazione componenti meccanici",
  "Pulizia e lucidatura macchinari linea produttiva",
  "Montaggio e controllo tubazioni industriali",
  "Sostituzione cilindri essiccatori",
  "Sostituzione cuscinetti componenti meccanici",
  "Sostituzione unità taglio carta a fine ciclo",
  "Installazione e realizzazione linee elettriche industriali",
  "Manutenzione macchinari taglio industriale"
];

export const divisionPages = {
  "divisione-energia": {
    badge: "DIVISIONE ENERGIA",
    title: "Divisione Energia",
    subtitle: "Sviluppo, realizzazione e gestione di impianti per la produzione di energia rinnovabile.",
    heroImage: "https://i.ibb.co/9H9WgdV4/22.jpg",
    cards: [
      {
        id: "fotovoltaici",
        title: "Impianti Fotovoltaici",
        description: "Impianti a terra e in elevazione, dimensionati su ogni esigenza.",
        image:
          "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1200&q=70",
        iconKey: "zap",
        anchorId: "fotovoltaici",
      },
      {
        id: "eolici",
        title: "Impianti Eolici",
        description: "Soluzioni utility-scale e mini-eolico, dalla progettazione alla gestione.",
        image:
          "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?auto=format&fit=crop&w=1200&q=70",
        iconKey: "refresh",
        anchorId: "eolici",
      },
      {
        id: "biomasse",
        title: "Impianti a Biomasse",
        description: "Impianti alimentati da prodotti agricoli e residui agro-forestali.",
        image:
          "https://images.unsplash.com/photo-1545243424-0ce743321e11?auto=format&fit=crop&w=1200&q=70",
        iconKey: "leaf",
        anchorId: "biomasse",
      },
      {
        id: "idroelettrici",
        title: "Impianti Idroelettrici",
        description: "Progetti di piccola e grande taglia nel rispetto del territorio.",
        image:
          "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=1200&q=70",
        iconKey: "building",
        anchorId: "idroelettrici",
      },
    ],
    sections: [
      {
        id: "fotovoltaici",
        anchorId: "fotovoltaici",
        title: "Impianti Fotovoltaici",
        paragraphs: [
          "Realizziamo impianti fotovoltaici a terra e in elevazione, definendo la soluzione più adatta in base a consumi, spazi disponibili e obiettivi economici.",
          "L’approccio integra analisi preliminare, progettazione esecutiva, installazione e messa in servizio, con focus su affidabilità e performance.",
        ],
        bullets: [
          "Analisi del sito e producibilità attesa",
          "Progettazione e gestione iter tecnico-autorizzativo (ove applicabile)",
          "Installazione e collaudo",
          "Manutenzione programmata e monitoraggio",
        ],
      },
      {
        id: "eolici",
        anchorId: "eolici",
        title: "Impianti Eolici",
        paragraphs: [
          "Sviluppiamo e gestiamo impianti eolici di grande e piccola taglia, includendo opzioni di mini-eolico per specifiche esigenze territoriali.",
        ],
        bullets: [
          "Valutazione risorsa eolica e layout",
          "Gestione forniture e coordinamento lavori",
          "Ottimizzazione produzione e disponibilità impianto",
        ],
      },
      {
        id: "biomasse",
        anchorId: "biomasse",
        title: "Impianti a Biomasse",
        paragraphs: [
          "Realizziamo impianti per la produzione di energia da biomasse, valorizzando sottoprodotti agricoli e residui di lavorazione agro-forestale.",
        ],
        bullets: [
          "Studio di fattibilità e approvvigionamento",
          "Progettazione impiantistica e integrazione sistemi",
          "Gestione operativa e manutenzione",
        ],
      },
      {
        id: "idroelettrici",
        anchorId: "idroelettrici",
        title: "Impianti Idroelettrici",
        paragraphs: [
          "Progettiamo e gestiamo impianti idroelettrici di piccola e grande dimensione adottando tecnologie eco-compatibili e processi orientati alla sostenibilità.",
        ],
        bullets: [
          "Analisi idrologica e configurazione impianto",
          "Scelta tecnologie e componenti",
          "Gestione e monitoraggio in esercizio",
        ],
      },
      {
        id: "operation-maintenance",
        anchorId: "operation-maintenance",
        title: "Operation & Maintenance",
        lead: "Gestione integrata per massimizzare resa produttiva ed efficienza operativa.",
        bullets: [
          "Monitoraggio, manutenzione e controllo per ottimizzazione della produzione",
          "Gestione amministrativa secondo normativa vigente",
          "Gestione strategica del portafoglio di produzione energetica",
        ],
      },
      {
        id: "consulting",
        anchorId: "consulting",
        title: "Consulting",
        lead: "Supporto tecnico, legale e commerciale per investimenti nel settore rinnovabili.",
        bullets: [
          "Ricerca opportunità e valutazione preliminare",
          "Pre-due diligence tecnica, legale e commerciale",
          "Assistenza in compravendite e contrattualistica",
          "Supporto a project finance, leasing o finanza corporate",
        ],
      },
    ],
  },
  "divisione-manutenzione": {
    badge: "DIVISIONE MANUTENZIONE",
    title: "Divisione Manutenzione",
    subtitle: "Manutenzione e gestione di impianti industriali per sicurezza, continuità e performance.",
    heroImage:
      "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=1400&q=70",
    cards: [
      {
        id: "periodica",
        title: "Manutenzione Periodica",
        description: "Controlli ricorrenti programmati per mantenere l’impianto efficiente.",
        image:
          "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=1200&q=70",
        iconKey: "refresh",
        anchorId: "manutenzione",
      },
      {
        id: "straordinaria",
        title: "Manutenzione Straordinaria",
        description: "Interventi di riparazione e ripristino per guasti e fermi imprevisti.",
        image:
          "https://i.ibb.co/QjvYhMXt/0b3d1cef443e48671284693e0aa10486959bb650-1050x591.avif",
        iconKey: "building",
        anchorId: "manutenzione",
      },
      {
        id: "pianificata",
        title: "Manutenzione Pianificata",
        description: "Piani di intervento basati su criticità e cicli produttivi.",
        image:
          "https://i.ibb.co/1GcCLsyt/8839-032-gestion-et-integration-de-maintenance-industrielle-cta-maintenance-industrielle.jpg",
        iconKey: "zap",
        anchorId: "manutenzione",
      },
      {
        id: "anticipata",
        title: "Manutenzione Preventiva",
        description: "Lavorazioni per prevenire usura e rotture e ridurre i consumi.",
        image:
          "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=70",
        iconKey: "leaf",
        anchorId: "manutenzione",
      },
    ],
    sections: [
      {
        id: "manutenzione",
        anchorId: "manutenzione",
        title: "Manutenzione degli impianti industriali",
        paragraphs: [
          "Operiamo nella manutenzione di impianti industriali in diversi ambiti, con personale qualificato e processi orientati a sicurezza, continuità operativa e qualità.",
          "Una manutenzione efficace permette di valorizzare gli investimenti su macchinari e linee produttive, riducendo fermi e ottimizzando risorse.",
        ],
        bullets: [
          "Manutenzione periodica: controlli ricorrenti",
          "Manutenzione straordinaria: riparazioni e ripristino",
          "Manutenzione pianificata: pianificazione controlli e interventi",
          "Manutenzione preventiva: attività che prevengono usura e rotture",
          "Obiettivi: tutela lavoratori, riduzione consumi, aumento vita utile, ottimizzazione risorse",
        ],
      },
      {
        id: "montaggio",
        anchorId: "montaggio",
        title: "Montaggio",
        paragraphs: [
          "Il montaggio di impianti industriali richiede competenze specifiche e attenzione alle normative. Gestiamo installazioni anche complesse, con controllo qualità e assistenza dedicata.",
        ],
        bullets: [
          "Rispetto delle norme e delle procedure di sicurezza",
          "Controllo materiali e componentistica",
          "Esecuzione conforme a progetto e verifiche finali",
        ],
      },
      {
        id: "capannoni",
        anchorId: "capannoni",
        title: "Progettazione e montaggio capannoni industriali",
        paragraphs: [
          "Progettiamo capannoni e prefabbricati industriali su misura, partendo da uno studio preliminare delle esigenze operative e logistiche.",
          "La fase di montaggio viene eseguita con cura per garantire resistenza, sicurezza e piena funzionalità delle strutture.",
        ],
      },
      {
        id: "chiavi-in-mano",
        anchorId: "chiavi-in-mano",
        title: "Impianti industriali chiavi in mano",
        paragraphs: [
          "Realizziamo impianti industriali pronti per l’avviamento, seguendo l’intero ciclo di lavoro dalla progettazione al commissioning.",
        ],
        bullets: ["Studio", "Progettazione di dettaglio", "Fornitura materiali", "Costruzione e montaggio", "Collaudo e commissioning"],
      },
      {
        id: "revamping",
        anchorId: "revamping",
        title: "Revamping",
        paragraphs: [
          "Supportiamo le aziende nel rinnovamento di impianti e sistemi obsoleti, pianificando interventi per minimizzare i tempi di fermo e migliorare efficienza e affidabilità.",
        ],
        bullets: ["Studio preliminare (tempi, convenienza, materiali)", "Upgrade e rinnovo componenti critici", "Sistemi efficienti, produttivi e aggiornati"],
      },
    ],
  },
  consulting: {
    badge: "CONSULTING",
    title: "Consulting",
    subtitle: "Servizi di consulenza tecnica, legale e commerciale per investimenti e asset rinnovabili.",
    heroImage:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=70",
    cards: [],
    sections: [
      {
        id: "overview",
        anchorId: "overview",
        title: "Cosa facciamo",
        paragraphs: [
          "Affianchiamo investitori e operatori nella valutazione di opportunità nel settore delle energie rinnovabili, offrendo un supporto integrato e un unico interlocutore.",
        ],
        bullets: [
          "Ricerca opportunità d’investimento e analisi preliminare",
          "Pre-due diligence tecnica, legale e commerciale",
          "Supporto in compravendite e negoziazione",
          "Strutturazione finanziaria (project finance, leasing, corporate)",
        ],
      },
    ],
  },
  revamping: {
    badge: "REVAMPING",
    title: "Revamping",
    subtitle: "Rinnovo e upgrade di impianti energetici e sistemi obsoleti per massime performance.",
    heroImage:
      "https://images.unsplash.com/photo-1581092335397-9aa3d1b40f1f?auto=format&fit=crop&w=1400&q=70",
    cards: [],
    sections: [
      {
        id: "overview",
        anchorId: "overview",
        title: "Interventi di revamping",
        paragraphs: [
          "Eseguiamo verifiche e interventi di upgrade su impianti esistenti per aumentare affidabilità, produttività ed efficienza, pianificando le attività per ridurre i fermi.",
        ],
        bullets: ["Analisi stato materiali e componenti", "Piano interventi e approvvigionamenti", "Upgrade sistemi obsoleti e collaudo"],
      },
    ],
  },
  costruzioni: {
    badge: "COSTRUZIONI",
    title: "Costruzioni",
    subtitle: "Progetti civili e industriali con approccio integrato, dalla progettazione alla consegna.",
    heroImage:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=70",
    cards: [],
    sections: [
      {
        id: "overview",
        anchorId: "overview",
        title: "Divisione Edilizia",
        paragraphs: [
          "Gestiamo nuove costruzioni e ristrutturazioni per edifici residenziali, produttivi e industriali, con coordinamento completo delle fasi operative.",
        ],
        bullets: ["Nuove costruzioni e ristrutturazioni", "Opere civili e industriali chiavi in mano", "Gestione tempi, qualità e sicurezza in cantiere"],
      },
    ],
  },
  "risparmio-energetico": {
    badge: "RISPARMIO ENERGETICO",
    title: "Risparmio Energetico",
    subtitle: "Interventi su impianti esistenti per ridurre consumi e migliorare l’efficienza.",
    heroImage:
      "https://images.unsplash.com/photo-1558449028-b53a39d100fc?auto=format&fit=crop&w=1400&q=70",
    cards: [],
    sections: [
      {
        id: "overview",
        anchorId: "overview",
        title: "Up-grade degli impianti",
        paragraphs: [
          "Analizziamo i consumi e proponiamo interventi per ridurre il fabbisogno energetico, con modelli contrattuali orientati al risultato e alla sostenibilità economica.",
        ],
        bullets: [
          "Studio preliminare e audit energetico",
          "Progettazione interventi e piano di implementazione",
          "Energy Performance Contract con ES.Co.",
        ],
      },
    ],
  },
};

export const servicePages = {
  "divisione-energia": {
    fotovoltaici: {
      badge: "IMPIANTI FOTOVOLTAICI",
      title: "Impianti Fotovoltaici",
      subtitle: "Impianti a terra e in elevazione, con kilowattaggi di qualsiasi dimensione.",
      images: [
        "https://i.ibb.co/9H9WgdV4/22.jpg",
        "https://i.ibb.co/4nBPXKB2/23.jpg",
        "https://i.ibb.co/FqYL8Hqn/25.jpg",
        "https://i.ibb.co/zHt9b38Q/27.jpg",
        "https://i.ibb.co/hxySKJxH/29.jpg"
      ],
      paragraphs: [
        "MTS Energia realizza impianti fotovoltaici a terra e in elevazione, dimensionati in base alle esigenze del cliente e alle caratteristiche del sito.",
        "L’attività comprende lo studio di fattibilità, la progettazione esecutiva, la realizzazione, il collaudo e l’allaccio alla rete, oltre alla manutenzione e al monitoraggio post-vendita."
      ],
      bullets: [
        "Studio di fattibilità e producibilità",
        "Progettazione esecutiva",
        "Installazione, collaudo e allaccio alla rete",
        "Opere civili e gestione cantieristica",
        "Manutenzione e monitoraggio impianti"
      ]
    },
    eolici: {
      badge: "IMPIANTI EOLICI",
      title: "Impianti Eolici",
      subtitle: "Sviluppo, realizzazione e gestione di impianti eolici e mini-eolico.",
      images: [
        "https://i.ibb.co/q3wWhrBF/31.jpg",
        "https://i.ibb.co/4nBPXKB2/23.jpg",
        "https://i.ibb.co/FqYL8Hqn/25.jpg",
        "https://i.ibb.co/hxySKJxH/29.jpg",
        "https://i.ibb.co/9H9WgdV4/22.jpg"
      ],
      paragraphs: [
        "MTS Energia sviluppa, realizza e gestisce impianti per la produzione di energia rinnovabile attraverso l’impiego di generatori eolici di grandi e piccole dimensioni (mini-eolico).",
        "Seguiamo i principali step che portano dalla fase autorizzativa alla costruzione e messa in esercizio, includendo l’analisi della risorsa anemometrica e la valutazione economico-finanziaria."
      ],
      bullets: [
        "Ricerca siti e iter amministrativo/autorizzativo",
        "Analisi della risorsa anemometrica",
        "Valutazione economica e finanziaria",
        "Progettazione e realizzazione impianto",
        "Esercizio e gestione dell’impianto"
      ]
    },
    biomasse: {
      badge: "IMPIANTI A BIOMASSE",
      title: "Impianti a Biomasse",
      subtitle: "Impianti alimentati da prodotti agricoli, materiali organici e residui agro-forestali.",
      images: [
        "https://i.ibb.co/FqYL8Hqn/25.jpg",
        "https://i.ibb.co/9H9WgdV4/22.jpg",
        "https://i.ibb.co/hxySKJxH/29.jpg",
        "https://i.ibb.co/zHt9b38Q/27.jpg",
        "https://i.ibb.co/q3wWhrBF/31.jpg"
      ],
      paragraphs: [
        "MTS Energia realizza e gestisce impianti per la produzione di energia rinnovabile attraverso l’impiego di prodotti agricoli, materiali organici e residui di lavorazione agro-forestale.",
        "Gestiamo l’intero processo: dallo studio di fattibilità alla progettazione, fino alla realizzazione e messa in esercizio dell’impianto."
      ],
      bullets: [
        "Valutazione investimento e studio di fattibilità",
        "Ricerca e individuazione sito per l’impianto",
        "Reperimento materiali e filiera di approvvigionamento",
        "Iter amministrativo/autorizzativo e realizzazione",
        "Gestione ed esercizio dell’impianto"
      ]
    },
    idroelettrici: {
      badge: "IMPIANTI IDROELETTRICI",
      title: "Impianti Idroelettrici",
      subtitle: "Progetti di piccola e grande taglia nel rispetto del territorio, con tecnologie eco-compatibili.",
      images: [
        "https://i.ibb.co/zHt9b38Q/27.jpg",
        "https://i.ibb.co/FqYL8Hqn/25.jpg",
        "https://i.ibb.co/4nBPXKB2/23.jpg",
        "https://i.ibb.co/q3wWhrBF/31.jpg",
        "https://i.ibb.co/9H9WgdV4/22.jpg"
      ],
      paragraphs: [
        "MTS Energia progetta, realizza e gestisce impianti idroelettrici, di piccole e grandi dimensioni, per la produzione di energia rinnovabile nel pieno rispetto del territorio.",
        "L’attività comprende ricerca siti, analisi della risorsa idrica, valutazioni economico-finanziarie, progettazione, realizzazione e gestione."
      ],
      bullets: [
        "Ricerca siti e iter amministrativo/autorizzativo",
        "Analisi della risorsa idrica",
        "Valutazione economica e finanziaria",
        "Progettazione e realizzazione impianto",
        "Esercizio e gestione dell’impianto"
      ]
    }
  },
  "divisione-manutenzione": {
    periodica: {
      badge: "MANUTENZIONE PERIODICA",
      title: "Manutenzione Periodica",
      subtitle: "Controlli ricorrenti programmati per garantire efficienza e continuità operativa.",
      images: [
        "https://i.ibb.co/hxySKJxH/29.jpg",
        "https://i.ibb.co/FqYL8Hqn/25.jpg",
        "https://i.ibb.co/9H9WgdV4/22.jpg",
        "https://i.ibb.co/zHt9b38Q/27.jpg",
        "https://i.ibb.co/q3wWhrBF/31.jpg"
      ],
      paragraphs: [
        "La manutenzione periodica è un controllo ricorrente, pianificato per ridurre i guasti e mantenere costante l’efficienza delle linee produttive.",
        "Interveniamo con procedure e check mirati, in linea con le normative e le esigenze specifiche del settore industriale."
      ],
      bullets: [
        "Piani di controllo e checklist per impianto",
        "Verifiche funzionali e sicurezza",
        "Riduzione fermi e aumento disponibilità",
        "Reportistica e tracciamento interventi"
      ]
    },
    straordinaria: {
      badge: "MANUTENZIONE STRAORDINARIA",
      title: "Manutenzione Straordinaria",
      subtitle: "Interventi di riparazione e ripristino per guasti e fermi imprevisti.",
      images: [
        "https://i.ibb.co/FqYL8Hqn/25.jpg",
        "https://i.ibb.co/hxySKJxH/29.jpg",
        "https://i.ibb.co/q3wWhrBF/31.jpg",
        "https://i.ibb.co/9H9WgdV4/22.jpg",
        "https://i.ibb.co/4nBPXKB2/23.jpg"
      ],
      paragraphs: [
        "La manutenzione straordinaria è un intervento di riparazione non programmato che ripristina la piena operatività dell’impianto.",
        "Gestiamo diagnosi, sostituzioni e ripristini con priorità su sicurezza e tempi di fermo ridotti."
      ],
      bullets: [
        "Diagnosi guasto e intervento rapido",
        "Riparazioni meccaniche ed elettriche",
        "Ripristino funzionale e collaudo",
        "Riduzione downtime e messa in sicurezza"
      ]
    },
    pianificata: {
      badge: "MANUTENZIONE PIANIFICATA",
      title: "Manutenzione Pianificata",
      subtitle: "Pianificazione controlli e interventi in base a criticità e cicli produttivi.",
      images: [
        "https://i.ibb.co/9H9WgdV4/22.jpg",
        "https://i.ibb.co/4nBPXKB2/23.jpg",
        "https://i.ibb.co/zHt9b38Q/27.jpg",
        "https://i.ibb.co/hxySKJxH/29.jpg",
        "https://i.ibb.co/q3wWhrBF/31.jpg"
      ],
      paragraphs: [
        "La manutenzione pianificata è la programmazione dei controlli in base a cicli di lavoro, criticità dei componenti e obiettivi di disponibilità impianto.",
        "Definiamo piani intervento, approvvigionamenti e finestre operative per ridurre l’impatto sulla produzione."
      ],
      bullets: [
        "Pianificazione interventi e risorse",
        "Ottimizzazione tempi e fermi programmati",
        "Gestione ricambi e materiali",
        "Allineamento a normative e procedure"
      ]
    },
    preventiva: {
      badge: "MANUTENZIONE PREVENTIVA",
      title: "Manutenzione Preventiva",
      subtitle: "Attività per prevenire usura e rotture, ottimizzando consumi e risorse.",
      images: [
        "https://i.ibb.co/zHt9b38Q/27.jpg",
        "https://i.ibb.co/hxySKJxH/29.jpg",
        "https://i.ibb.co/9H9WgdV4/22.jpg",
        "https://i.ibb.co/4nBPXKB2/23.jpg",
        "https://i.ibb.co/FqYL8Hqn/25.jpg"
      ],
      paragraphs: [
        "La manutenzione preventiva comprende lavorazioni che prevengono l’usura e la rottura dei sistemi, migliorando sicurezza e affidabilità.",
        "L’obiettivo è aumentare la durata di vita delle linee produttive, ridurre consumi e ottimizzare le risorse disponibili."
      ],
      bullets: [
        "Riduzione guasti e interventi correttivi",
        "Aumento vita utile macchinari",
        "Riduzione consumi e inefficienze",
        "Miglioramento sicurezza per operatori"
      ]
    }
  }
};
